import { Component } from "react"
import PropTypes from "prop-types"
import parse from "html-react-parser"
import classnames from "classnames"

import SortableWrapper from "shared/components/sortable_wrapper"
import editIcon from "images/partners/edit.svg?raw"
import IngredientForm from "./ingredient_form"
import { getQueryIngredients } from "./gql"
import { getQueries } from "../queries/gql"
import { reorderStepIngredientsMutation } from "./gql"

import styles from "./ingredients.module.scss"
import { arrayReplace } from "shared/lib/utils"

class Ingredients extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ingredients: [],
      queries: props.queries,
      showNewForm: false,
    }
  }

  componentDidMount() {
    getQueryIngredients(this.props.parent).then(ingredients => {
      this.setState({ ingredients })
    })
    if (!this.state.queries) {
      getQueries(this.props.service.slug).then(queries => {
        this.setState({ queries })
      })
    }
  }

  updateIngredients = (action, ingredient) => {
    let ingredients = this.state.ingredients
    const index = ingredients.findIndex(i => i.id === ingredient.id)

    switch (action) {
      case "add":
        ingredients = [...ingredients, ingredient]
        break
      case "update":
        ingredients = arrayReplace(ingredients, index, ingredient)
        break
      case "delete":
        ingredients = ingredients.filter(i => i.id !== ingredient.id)
        break
    }
    this.setState({ ingredients })
  }

  toggleNewForm = () => {
    this.setState({ showNewForm: !this.state.showNewForm })
  }

  handleOrderChange = newIngredients => {
    const oldIngredients = this.state.ingredients
    newIngredients.forEach((f, index) => (f.weight = index))
    this.setState({ ingredients: newIngredients })
    const sortedIngredientsIds = newIngredients.map(i => i.id)

    reorderStepIngredientsMutation(
      this.props.service.slug,
      "query",
      this.props.parent.module_name,
      sortedIngredientsIds
    )
      .then(ingredientsResp => {
        window.appendFlash("Ingredients reordered")
      })
      .catch(errs => {
        this.setState({ ingredients: oldIngredients })
        window.appendFlash("Could not reorder ingredients — please try again", "danger")
      })
  }

  render() {
    return (
      <>
        <section className="ingredient-sections ingredient-inputs form-section">
          <a id="banned_label"></a>
          <a id="banned_helper"></a>
          <a id="banned_dropdown"></a>
          <a id="ingredients"></a>
          <h3>Ingredients</h3>

          <p>
            Ingredients are the pieces of data used to transfer information about the query event to another action on
            IFTTT. Each query is required to have at least one ingredient. For example, the query "List Calendars"
            should have a CalendarName ingredient that can be used in an action field. Read the full documentation on{" "}
            <a href={`${this.props.glossaryUrl}#ingredient`}>ingredients</a>.
          </p>

          <SortableWrapper
            signature={this.state.ingredients.map(i => i.id).join(":")}
            items={this.state.ingredients}
            onOrderUpdate={this.handleOrderChange}
          >
            <ul className="ingredient-list draggable-list">
              {this.state.ingredients.map(i => (
                <IngredientItem
                  key={i.id}
                  {...this.props}
                  queries={this.state.queries}
                  ingredient={i}
                  updateIngredients={this.updateIngredients}
                />
              ))}
            </ul>
          </SortableWrapper>

          {this.state.showNewForm ? (
            <div className={styles["field-edit"]}>
              <IngredientForm
                {...this.props}
                ingredient={{}}
                updateIngredients={this.updateIngredients}
                hideForm={this.toggleNewForm}
                queries={this.state.queries}
                create
              />
            </div>
          ) : (
            <div className="action">
              <button
                onClick={this.toggleNewForm}
                disabled={this.props.service.is_published}
                className="button-tertiary add-field"
              >
                Add ingredient +
              </button>
            </div>
          )}
        </section>
      </>
    )
  }
}

Ingredients.propTypes = {
  service: PropTypes.object.isRequired,
  parent: PropTypes.object.isRequired,
  parentType: PropTypes.string.isRequired,
  glossaryUrl: PropTypes.string.isRequired,
  queries: PropTypes.array,
}

class IngredientItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showForm: false,
    }
  }

  toggleForm = () => {
    this.setState({ showForm: !this.state.showForm })
  }

  render() {
    if (this.state.showForm) {
      return (
        <div className={styles["field-edit"]}>
          <IngredientForm {...this.props} hideForm={this.toggleForm} />
        </div>
      )
    } else {
      return (
        <li>
          {this.props.ingredient.name}
          <span className="links">
            <a title="Edit ingredient" onClick={this.toggleForm}>
              <span className="svg-edit-icon">{parse(editIcon)}</span>
            </a>
          </span>
        </li>
      )
    }
  }
}

IngredientItem.propTypes = {
  service: PropTypes.object.isRequired,
  parent: PropTypes.object.isRequired,
  parentType: PropTypes.string.isRequired,
  updateIngredients: PropTypes.func.isRequired,
  queries: PropTypes.array,
  ingredient: PropTypes.object,
}

export default Ingredients
